import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class DefaultController {

  constructor(app) {
    this.app = app;
  }
  show(path, model) {

    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
  CreateRoom (room) {
    //join room
    const app = this.app;
    app.joinCustomRoom(room);
  }
}